<template>
  <div>
    <div class="row">
      <div class="col-md-4">
        <div class="card">
          <!-- <input type="file" @change="subirArchivoAdicional($event)" /> -->


                  <div class="custom-file">
                    <input type="file" class="custom-file-input" id="customFileLang" lang="es" @change="subirArchivoAdicional($event)">
                    <label class="custom-file-label" for="customFileLang"></label>
                  </div>
                
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col">
        <div class="card">
          <div class="col">
            <h1>
              NOTA:
              <p>
                Los Centros deben venir separados por el caracter " ; " al igual
                que las jaulas por centro.
              </p>
            </h1>
            <h4>COLUMNAS DEL EXCEL:</h4>
            <p>- A: para los codigos de ticket</p>
            <p>- B: para el numero de la guia</p>
            <p>- C: para los codigos siep (centros)</p>
            <p>- D: para los numeros de jaulas</p>
            <h3>EJEMPLO:</h3>
            <table class="table">
              <thead>
                <tr>
                  <th>TICKET (columna A)</th>
                  <th>GUIA (columna B)</th>
                  <th>CENTROS (columna C)</th>
                  <th>JAULAS (columna D)</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>125551</td>
                  <td>26503</td>
                  <td>101205 <span style="font-size:1.5em;">;</span> 115485</td>
                  <td>202-117 <span style="font-size:1.5em;">;</span> 101-205</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col">
        <div class="card" style="min-height: 380px">
          <div class="col">
            <h2>RESULTADO PROCESAMIENTO:</h2>
            <div
              style="height: 320px; overflow: auto; border: 1px solid #c3c3c3"
            >
              <ul style="list-style-type: none">
                <li v-for="(e, idx) in errores" :key="idx">
                  <span class="badge badge-dot mr-4">
                    <i class="bg-danger"></i>
                    <span class="status">{{ e }}</span>
                  </span>
                </li>

                <li v-for="(m, idx) in mensajes" :key="idx">
                  <span class="badge badge-dot mr-4">
                    <i class="bg-success"></i>
                    <span class="status">{{ m }}</span>
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  data: () => ({
    file: null,
    mensaje: "",
    mensajes: [],
    errores: [],
  }),
  methods: {
    async subirArchivoAdicional($event) {
      let loader = this.$loading.show({
        // Optional parameters
        //container: this.fullPage ? null : this.$refs.formContainer,
        canCancel: false,
        color: "#262b63",
        backgroundColor: "#ededed",
        //onCancel: this.onCancel,
        loader: "spinner",
      });
      //this.file = $event.target.files[0];
      let formData = new FormData();
      formData.append("file", $event.target.files[0]);
      await this.axios
        .post(
          `${this.api}/subir_archivo_importacion_centros`,
          formData,
          this.cabeceras_archivo
        )
        .then((res) => {
          this.mensaje = res.data.mensaje;
          this.mensajes = res.data.mensajes;
          this.errores = res.data.errores;
          loader.hide();
        })
        .catch((e) => {
          console.log(e);
          loader.hide();
        });
    },
  },
  computed: {
    ...mapState(["api", "cabeceras_archivo"]),
  },
};
</script>